// extracted by mini-css-extract-plugin
module.exports = {"arrowButton":"ArrowButton-module--arrowButton--2BW7X","icon":"ArrowButton-module--icon--1NRg5"};